import {callApi} from '@/lib/api/callApi';

/**
 * 搜尋機構
 * @param {Object} params 參數
 * @returns {Promise} promise
 */
async function getAgency(params) {
  const res = await callApi({
    category: 'agency',
    apiName: '',
    method: 'get',
    params,
  });
  return res.data;
}

/**
 * 創建機構
 * @param {Object} data 參數
 * @returns {Promise} promise
 */
async function createAgency(data) {
  const res = await callApi({
    category: 'agency',
    apiName: '',
    method: 'post',
    data,
  });
  return res.data;
}

/**
 * 取得機構資訊
 * @param {Number} id id
 * @returns {Promise} promise
 */
async function getAgencyById(id) {
  const res = await callApi({
    category: 'agency',
    apiName: id,
    method: 'get',
  });
  return res.data;
}

/**
 * 更新機構資訊
 * @param {Number} id id
 * @param {Object} data 參數
 * @returns {Promise} promise
 */
async function updateAgency(id, data) {
  const res = await callApi({
    category: 'agency',
    apiName: `/${id}`,
    method: 'patch',
    data,
  });
  return res.data;
}

/**
 * 刪除機構
 * @param {Number} id id
 * @returns {Promise} promise
 */
async function deleteAgency(id) {
  const res = await callApi({
    category: 'agency',
    apiName: `/${id}`,
    method: 'delete',
  });
  return res.data;
}

export default {
  getAgency,
  createAgency,
  getAgencyById,
  updateAgency,
  deleteAgency,
};
